module.exports = __webpack_public_path__ + "img/Heavy-lifting-scaled.445cfe6c.jpg";